import React from 'react';
import { Paper, Typography, List, ListItem, ListItemText, Divider, Box, Button } from '@mui/material';

interface Props {
    token: string,
    kayttajaId: number
}

const Ohjeet: React.FC<Props> = (props: Props): React.ReactElement => {
    return (
        <Box sx={{ maxWidth: 800, margin: '0 auto', padding: 2 }}>
            <Paper elevation={3} sx={{ padding: 3 }}>
                <Typography variant="h4" gutterBottom>
                    Tervetuloa Vek e-Kirja -sovellukseen!
                </Typography>

                <Typography variant="body1" paragraph>
                    Tämä sovellus on suunniteltu työvuorojen ja junien kirjaamiseen. Se tarjoaa helpon tavan syöttää ja hallita työvuoroja sekä niihin liittyviä junia.
                </Typography>

                <Divider sx={{ marginY: 2 }} />

                <Typography variant="h6" gutterBottom>
                    📅 Työvuoron lisääminen
                </Typography>
                <List>
                    <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: 4 }}>
                        <ListItem>
                            <ListItemText primary="1. Valitse 'Lisää uusi työvuoro' valikosta." />
                        </ListItem>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: 2,
                            marginBottom: 2,
                            padding: 2,
                            backgroundColor: 'darkgray', // Vaaleanharmaa tausta
                            borderRadius: '8px', // Pyöristetyt kulmat
                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', // Hieno varjo
                        }}>
                            <img
                                src="/images/tut01.png"
                                alt="Ohjeet kuva"
                                style={{
                                    maxWidth: '80%',
                                    height: 'auto',
                                    borderRadius: '8px', // Pyöristetyt kulmat kuvassa
                                }}
                            />
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: 4 }}>
                        <ListItem>
                            <ListItemText primary="2. Lisää vuoron aloitus- ja lopetusaika" />
                        </ListItem>
                        <ListItemText secondary="Vuoron lisät lasketaan automaattisesti" />
                        <ListItemText secondary="HUOM! Jos vuorossa on lepo." />
                        <ListItemText secondary="Merkitse molemmat vuoron osat erikseen. Esim. vuoro alkaa klo 16:00 ja loppuu klo 08:00. Työvuoroon sisältyy lepo välillä 22:00 - 04:00. Vek e-Kirjaan merkitään kaksi vuoroa: 16:00 - 22:00 ja 04:00 - 08:00. Valitse ensimmäiseen vuoron osaan myös täppä: [Vuorossa on lepo / TSL]" />
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: 2,
                            marginBottom: 2,
                            padding: 2,
                            backgroundColor: 'darkgray', // Vaaleanharmaa tausta
                            borderRadius: '8px',
                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                        }}>
                            <img
                                src="/images/tut02.png"
                                alt="Ohjeet kuva"
                                style={{
                                    maxWidth: '80%',
                                    height: 'auto',
                                    borderRadius: '8px', // Pyöristetyt kulmat
                                }}
                            />
                        </Box>


                        <ListItem>
                            <ListItemText primary="3. Lisää työvuoron junat" />
                        </ListItem>
                        <ListItemText secondary="Valitse päivämääräksi junan lähtöpäivä ja lisää junan numero" />
                        <ListItemText secondary="Valitse ajamasi matka pudotusvalikoista " />
                        <ListItemText secondary="Jos valikot eivät ilmesty tai niissä on vääriä liikennepaikkoja, yritä syöttää päivämäärä tai junanumero uudestaan." />
                        <ListItemText secondary="Valitse täppä [Pakettimatka] jos kyseessä on matkustus " />
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: 2,
                            marginBottom: 2,
                            padding: 2,
                            backgroundColor: 'darkgray', // Vaaleanharmaa tausta
                            borderRadius: '8px',
                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                        }}>
                            <img
                                src="/images/tut03.png"
                                alt="Ohjeet kuva"
                                style={{
                                    maxWidth: '80%',
                                    height: 'auto',
                                    borderRadius: '8px', // Pyöristetyt kulmat
                                }}
                            />
                        </Box>
                    </Box>









                    <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: 4 }}>
                        <ListItem>
                            <ListItemText primary="4. Lisää junan tiedot." />

                        </ListItem>
                        <ListItemText secondary="Osa tiedoista haetaan automaattisesti eri palveluista, mutta voit halutessasi muokata kaikkia tietoja. Esimerkiksi ratakilometrit ovat vain karkea arvio kahden liikennepaikan välillä. Myös matkustajajunien pituuksissa voi olla heittoa. " />
                        <ListItemText secondary="Tarkista tiedot aina Kentästä. Vek e-Kirjan tietoja ei saa käyttää junan ajamiseen!" />
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: 2,
                            marginBottom: 2,
                            padding: 2,
                            backgroundColor: 'darkgray', // Vaaleanharmaa tausta
                            borderRadius: '8px', // Pyöristetyt kulmat
                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', // Hieno varjo
                        }}>
                            <img
                                src="/images/tut04.png"
                                alt="Ohjeet kuva"
                                style={{
                                    maxWidth: '80%',
                                    height: 'auto',
                                    borderRadius: '8px', // Pyöristetyt kulmat kuvassa
                                }}
                            />

                        </Box>
                        <ListItemText secondary="Kun olet lisännyt junan tiedot: klikkaa [Lisää juna työvuoroon] Oletuksena sovellus varmistaa, että kaikki tiedot on syötetty. Jos kuitenkin haluat pitää tilastoa vajanaisemmilla tiedoilla, tämä onnistuu valitsemalla [Pakettimatka] täppä." />

                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: 2,
                            marginBottom: 2,
                            padding: 2,
                            backgroundColor: 'darkgray', // Vaaleanharmaa tausta
                            borderRadius: '8px', // Pyöristetyt kulmat
                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', // Hieno varjo
                        }}>
                            <img
                                src="/images/tut05.png"
                                alt="Ohjeet kuva"
                                style={{
                                    maxWidth: '80%',
                                    height: 'auto',
                                    borderRadius: '8px', // Pyöristetyt kulmat
                                }}
                            />
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: 4 }}>
                        <ListItem>
                            <ListItemText primary="5. Lisää muita junia tai tallenna työvuoro" />
                        </ListItem>
                        <ListItemText secondary="Lisää työvuoron muut junat kohdassa 4. kuvatulla tavalla." />
                        <ListItemText secondary="Työvuoron junat näkyvät listassa ja niitä voi vielä muokata [kynäikonista] tai poistaa [roskakori-ikonista] Huomaa, että junaa eikä sen paremmin työvuoroakaan ole vielä tässä kohtaa tallennettu. Vasta kun klikkaat [Tallenna Työvuoro] nappia, tehdyt muutokset tallennetaan palvelimelle " />
                        <ListItemText secondary="Muista laittaa täppä [Vuorossa on lepo / TSL], jos kyseessä on kaksiosaisen vuoron ensimmäinen osa. " />
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: 2,
                            marginBottom: 2,
                            padding: 2,
                            backgroundColor: 'darkgray', // Vaaleanharmaa tausta
                            borderRadius: '8px',
                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                        }}>
                            <img
                                src="/images/tut06.png"
                                alt="Ohjeet kuva"
                                style={{
                                    maxWidth: '80%',
                                    height: 'auto',
                                    borderRadius: '8px', // Pyöristetyt kulmat
                                }}
                            />
                        </Box>
                    </Box>

                </List>



                <Divider sx={{ marginY: 2 }} />

                <Typography variant="h6" gutterBottom>
                    🧠 Älykkäät automaattiset ominaisuudet
                </Typography>
                <List>
                    <ListItem>
                        <ListItemText primary=" Junan liikennepaikat ja aikataulu, ja myöhästymisminuutit" />
                    </ListItem>
                    <ListItemText secondary="Kaikkien junien aikataulutiedot haetaan automaattisesti. Edellytyksenä on, että junalle on syötetty oikea päivämäärä. Myöhästymisminuutit voidaan hakea myös jälkikäteen junan numeron vieressä olevasta [Päivitysikonista] " />

                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: 2,
                        marginBottom: 2,
                        padding: 2,
                        backgroundColor: 'darkgray', // Vaaleanharmaa tausta
                        borderRadius: '8px',
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                    }}>
                        <img
                            src="/images/tut07.png"
                            alt="Ohjeet kuva"
                            style={{
                                maxWidth: '80%',
                                height: 'auto',
                                borderRadius: '8px', // Pyöristetyt kulmat
                            }}
                        />
                    </Box>
                    <ListItem>
                        <ListItemText primary="2. Henkilöjunan pituus" />
                    </ListItem>
                    <ListItemText secondary="Henkilöjunan pituuksissa saattaa olla virheitä. Jos pituus ei näy ollenkaan voit yrittää syöttää junan liikennepaikat uudestaan." />
                    <ListItemText secondary="Joissain tilanteissa haetaan myös automaattisesti Jarrupaino ja JPP, mutta tämä on vasta kokeellinen ominaisuus. " />

                    <ListItem>
                        <ListItemText primary="3. Kentän kalenteritiedosto ja vienti Exceliin" />

                    </ListItem>
                    <ListItemText secondary="Jos haluat säästää aikaa voit lisätä myös työvuorot helposti Kentän kalenteritiedostoa apuna käyttäen." />
                    <ListItemText secondary="Lataa tiedosto Kentästä: Huom! avaa Kentän kalenterilinkki ja lataa linkistä saatava *.ics päätteinen tiedosto puhelimellesi / tietokoneelle. Vek e-Kirja osaa lukea työvuorot tästä tiedostosta kun painat [Avaa Kentän kalenteritiedosto] -nappia" />
                    <ListItemText secondary="Lisää avautuvasta listasta haluamasi työvuorot [Kellokuvaketta] painamalla." />
                    <ListItemText secondary="Huom! Kentän tiedostossa on mukana myös lepoja. Varo ettet vahingossa lisää niitä Vek e-Kirjan työvuoroihin" />
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: 2,
                        marginBottom: 2,
                        padding: 2,
                        backgroundColor: 'darkgray', // Vaaleanharmaa tausta
                        borderRadius: '8px',
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                    }}>
                        <img
                            src="/images/tut08.png"
                            alt="Ohjeet kuva"
                            style={{
                                maxWidth: '80%',
                                height: 'auto',
                                borderRadius: '8px', // Pyöristetyt kulmat
                            }}
                        />
                    </Box>
                    <ListItemText secondary="On suositeltavaa myös tallentaa vuoroista välillä varmuuskopioita Exceliin. Vek e-Kirja ei ole vastuussa, jos työvuorot jostain syystä häviävät" />
                    <ListItem>
                        <ListItemText primary="4. Aiemmin tallennetut vuorot " />

                    </ListItem>
                    <ListItemText secondary="vek e-Kirja osaa hyödyntää myös aikaisemmin syötettyjen vuorojen dataa ja tarjoaa aikaisempien vuorojen perusteella vastaavia junia." />
                    <ListItemText secondary="Käy kuitenkin vielä junan tiedot läpi (muokkaa junaa [kynäikonista]) ja varmista, että tiedot ovat oikein." />
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: 2,
                        marginBottom: 2,
                        padding: 2,
                        backgroundColor: 'darkgray', // Vaaleanharmaa tausta
                        borderRadius: '8px',
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                    }}>
                        <img
                            src="/images/tut09.png"
                            alt="Ohjeet kuva"
                            style={{
                                maxWidth: '80%',
                                height: 'auto',
                                borderRadius: '8px', // Pyöristetyt kulmat
                            }}
                        />
                    </Box>
                </List>

                <Divider sx={{ marginY: 2 }} />

                <Typography variant="h6" gutterBottom>
                    💡 Lisäohjeet:
                </Typography>
                <ListItemText secondary="Jos tarvitset lisäohjeita, voit ottaa pienellä kynnyksellä yhteyttä sovelluksen kehittäjään." />
                <ListItemText secondary="  Liity myös Henkan Koodivarikon Patroniksi niin olet mukana palvelinkulujen ylläpitämisessä ja pääset tutustumaan myös muihin Henkan Koodivarikon projekteihin." />



                <Button
                    variant="contained"
                    color="inherit"
                    href="https://patreon.com/HenkanKoodivarikko?utm_medium=unknown&utm_source=join_link&utm_campaign=creatorshare_creator&utm_content=copyLink"
                    target="_blank"
                    fullWidth
                    rel="noopener noreferrer"
                    sx={{
                        height: 80,
                        textTransform: 'none',
                        my: 5,

                        fontWeight: 'bold',
                        boxShadow: 2,
                        '&:hover': { boxShadow: 4, backgroundColor: 'primary.dark' }
                    }}
                >
                    🚀 TUE KEHITYSTÄ!
                </Button>

            </Paper>
        </Box>
    );
};

export default Ohjeet;
